export default "__VITE_ASSET__dUWj6zt3__"